import { FC, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { Button } from "..";
import {
  selectAuthCompany,
  selectAuthLoadingBrandRegister,
} from "../../store/selectors/auth";
import { SelectionCompetitorsProps } from "./types";
import Loading from "../Loading/Loading";
import analytics from "../../lib/Analytics";
import { CompetitorWithLogo } from "../../types/competitor";
import BrandLogo from "../BrandLogo/BrandLogo";

import styles from "./SelectionCompetitors.module.css";



const SelectionCompetitors: FC<SelectionCompetitorsProps> = ({
  competitors,
  loading,
  styleLoading,
  classNameHeader,
  classNameTitle,
  classNameCaption,
  textButton,
  typeButton,
  onSubmit,
  onReroll
}) => {
  const company = useSelector(selectAuthCompany);
  const loadingBrandRegister = useSelector(selectAuthLoadingBrandRegister);
  const [selectedCompetitors, setSelectedCompetitors] = useState<CompetitorWithLogo[]>([]);

  useLayoutEffect(() => {
    if (competitors) {
      setSelectedCompetitors(competitors);
    }
  }, [competitors]);

  const handleSelectCompetitor = (competitor: CompetitorWithLogo) => {
    const isSelected = selectedCompetitors.some((c) => c.name === competitor.name);

    if (isSelected) {
      setSelectedCompetitors(selectedCompetitors.filter((c) => c.name !== competitor.name));
    } else {
      setSelectedCompetitors([...selectedCompetitors, competitor]);
    }
  }

  const handleOnSubmit = () => {
    onSubmit(selectedCompetitors);

    const competitorsString = selectedCompetitors.map((c) => c.name).join(',');

    // 'Competitors suggested' is tracked in saga, only track 'Competitors confirmed' here
    analytics.track('Competitors confirmed', {
      competitors: competitorsString
    });

    // Save competitors to user profile properties
    analytics.setUserProperties({
      competitors: competitorsString,
      competitors_count: selectedCompetitors.length
    });
  }

  const renderCompetitors = () => {
    return (
      <section className={classNames(styles.competitors__list, styles.selecting)}>
        <div className={styles.selecting__wrapper}>

          {competitors && competitors.length > 0 ? (
            competitors.map((competitor: CompetitorWithLogo) => {
              const isSelected = selectedCompetitors.some((c) => c.name === competitor.name);

              return (<button
                key={competitor.name}
                className={styles.selecting__item}
                onClick={() => handleSelectCompetitor(competitor)}>
                <article className={classNames(styles["card-selecting"], styleLoading === 'dark' && styles["is-dark"], !isSelected && styles["is-disabled"])}>
                  <div className={styles["card-selecting__content"]}>
                    <BrandLogo
                      logoUrl={competitor.logoUrl}
                      name={competitor.name}
                      size="medium"
                      isSelected={isSelected}
                      className={styles["card-selecting__logo"]}
                    />
                    <h3 className={styles["card-selecting__title"]}>{competitor.name}</h3>
                  </div>
                  <div className={styles["card-selecting__action"]}>
                    <div className={styles["card-selecting__select"]}>
                      <img src="/select.svg" alt="Remove" />
                    </div>
                    <p className={styles["card-selecting__remove"]}>Remove</p>
                  </div>
                </article>
              </button>);
            })
          ) : (
            <p className={styles["selecting__empty-text"]}>No competitors found</p>
          )}
        </div>

        <footer className={styles.selecting__footer}>
          {competitors && company && !competitors.length && <Button
            typeStyle="outline-white"
            size="lg"
            className={styles.selecting__button}
            onClick={() => onReroll(company)}>
            Reroll
          </Button>}
          <Button
            typeStyle={typeButton || "outline-white"}
            size="lg"
            className={styles.selecting__button}
            onClick={handleOnSubmit}>
            {textButton || 'Continue'}
          </Button>
        </footer>
      </section>
    );
  }

  return (
    <div className={styles.competitors}>
      <header className={classNames(styles.competitors__header, classNameHeader)}>
        <p className={styles.competitors__label}>{company?.name}</p>
        <h1 className={classNames(styles.competitors__title, classNameTitle)}>Here’s the lowdown on your competitors, fresh off the press</h1>
        <p className={classNames(styles.competitors__caption, classNameCaption)}>Oh, if we slipped up, just hit that reroll — or you can totally tweak everything in the dashboard, possibilities are limitless!</p>
      </header>

      {loading || loadingBrandRegister ?
        <Loading className={styles.competitors__loading} caption="Powering up your insights ..." style={styleLoading} /> :
        renderCompetitors()}

    </div>
  );
};

export default SelectionCompetitors;













